import { useState, useEffect } from 'react';

const useBreakpoint = () => {
  const getBreakpoint = () => {
    const width = window.innerWidth;
    if (width <= 600) return 'small';
    if (width <= 1024) return 'medium';
    return 'large';
  };

  const [breakpoint, setBreakpoint] = useState(getBreakpoint());

  useEffect(() => {
    const handleResize = () => {
      const newBreakpoint = getBreakpoint();
      setBreakpoint(newBreakpoint);
    };

    window.addEventListener('resize', handleResize);
    // Clean up on unmount.
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoint;
};

export default useBreakpoint;
